if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          button: this.querySelector('button.localization-form__select'),
          closeButton: this.querySelector('.country-selector__close-button'),
          panel: this.querySelector('.disclosure__list-wrapper')
        };
        this.elements.button.addEventListener('click', this.togglePanel.bind(this));
        
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.togglePanel.bind(this));
        }
        
        // Add click handler for links to allow them to open normally
        this.querySelectorAll('a').forEach(link => {
          link.addEventListener('click', (event) => {
            // Only prevent default if it's not a target='_blank' link
            if (!link.target || link.target !== '_blank') {
              event.preventDefault();
            }
          });
        });
      }

      togglePanel() {
        const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
        this.elements.button.setAttribute('aria-expanded', !isExpanded);
        this.elements.panel.toggleAttribute('hidden');
      }
    }
  );
}
